import React, { useState } from 'react';
import styles from './autopayToggle.module.css';
import { getTextStyles } from '../../../utils/textStyleUtils';

interface AutopayToggleProps {
  enableText: {
    text: string;
    style?: {
      textStyle?: string;
      textColor?: string;
    };
  };
  defaultAutopay?: boolean;
  onToggle?: (enabled: boolean) => void;
}

const AutopayToggle: React.FC<AutopayToggleProps> = ({
  enableText,
  defaultAutopay = true,
  onToggle,
}) => {
  const [isEnabled, setIsEnabled] = useState(defaultAutopay);

  const handleToggle = () => {
    const newValue = !isEnabled;
    setIsEnabled(newValue);
    if (onToggle) {
      onToggle(newValue);
    }
  };

  return (
    <div className={styles.autopayContainer}>
      <label className={styles.toggleLabel}>
        <input
          type="checkbox"
          checked={isEnabled}
          onChange={handleToggle}
          className={styles.toggleInput}
        />
        <span className={styles.toggleSwitch}></span>
        <span
          className={styles.toggleText}
          style={getTextStyles(enableText.style)}
        >
          {enableText.text}
        </span>
      </label>
    </div>
  );
};

export default AutopayToggle;

